import(/* webpackMode: "eager", webpackExports: ["SidebarItemsProvider"] */ "/vercel/path0/src/app/v1/[communitySlug]/providers/SidebarItemsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/v3/layout/CommunityViewLayout.tsx");
